import React from "react";
import { Grid, Box } from "@mui/material";
import CardComponent from "./Card";

const CardWrapper = () => {
  return (
    <Box sx={{ flexGrow: 1, p: 2 }}>
      <Grid container spacing={2}>
        <Grid item>
          <CardComponent />
        </Grid>
        <Grid item>
          <CardComponent />
        </Grid>
        <Grid item>
          <CardComponent />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CardWrapper;
